import { render, staticRenderFns } from "./confirm.vue?vue&type=template&id=46fb10e0&scoped=true"
import script from "./confirm.vue?vue&type=script&lang=js"
export * from "./confirm.vue?vue&type=script&lang=js"
import style0 from "./confirm.vue?vue&type=style&index=0&id=46fb10e0&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46fb10e0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src881454487/src/clients/ap3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('46fb10e0')) {
      api.createRecord('46fb10e0', component.options)
    } else {
      api.reload('46fb10e0', component.options)
    }
    module.hot.accept("./confirm.vue?vue&type=template&id=46fb10e0&scoped=true", function () {
      api.rerender('46fb10e0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/confirm.vue"
export default component.exports